import * as R from 'ramda';
import { GetOrderProductIds } from '../../../stores/OrderBook/orderBook.types';
import onlineOrderBookStoreRepository from '../../../stores/OrderBook/repository/onlineOrderBookStore.repository';
import { offlineOrdersRepository } from '../repositories/offlineOrders.repository';
import { createApiSauceResponse } from '../utils/createApiSauceResponse.util';

export const onlineOrderBookStoreRepositoryOfflineAdapters = (): ReturnType<
  typeof onlineOrderBookStoreRepository
> => {
  return {
    getOrderProductIds: async (orderId: string) => {
      const order = await offlineOrdersRepository.getById(orderId);
      const { productColorIds, kitIds } = order?.products?.reduce(
        (acc, product) => {
          if (product.productColor?.id) {
            acc.productColorIds.push(product.productColor.id);
          }
          if (product.kit?.id) {
            acc.kitIds.push(product.kit.id);
          }

          return acc;
        },
        { productColorIds: [] as string[], kitIds: [] as string[] },
      ) ?? { productColorIds: [], kitIds: [] };

      const ids: GetOrderProductIds = {
        kitIds: R.uniq(kitIds) || [],
        productColorIds: productColorIds || [],
      };

      return createApiSauceResponse<GetOrderProductIds>({
        ok: true,
        data: ids,
      });
    },
  };
};
